import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=bb58e4c8&scoped=true&"
import script from "./normal.vue?vue&type=script&lang=js&"
export * from "./normal.vue?vue&type=script&lang=js&"
import style0 from "./normal.vue?vue&type=style&index=0&id=bb58e4c8&scoped=true&lang=css&"
import style1 from "./normal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb58e4c8",
  null
  
)

export default component.exports